import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconGraphQl = ({
  title = "GraphQL",
  viewBoxWidth = 93,
  viewBoxHeight = 72,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <path
      fill="#a5152a"
      d="m87.4 20.1c-.8 0-1.5.2-2.2.5l-11.8-12.8c.4-.7.6-1.5.6-2.4 0-2.8-2.3-5.1-5.1-5.1-2.3 0-4.3 1.5-4.9 3.7h-12.6c-.6-2.1-2.6-3.7-4.9-3.7s-4.3 1.5-4.9 3.7h-12.4c-.6-2.1-2.6-3.7-4.9-3.7-2.8 0-5.1 2.3-5.1 5.1 0 .8.2 1.6.5 2.3l-12 12.9c-.7-.3-1.4-.5-2.2-.5-2.8 0-5.1 2.3-5.1 5.1s2.3 5.1 5.1 5.1c.8 0 1.6-.2 2.3-.6l11.8 11.8c-.3.7-.5 1.4-.5 2.3 0 2.8 2.3 5.1 5.1 5.1.8 0 1.6-.2 2.2-.5l15.4 15.5c-.3.7-.5 1.4-.5 2.2 0 2.8 2.3 5.1 5.1 5.1s5.1-2.3 5.1-5.1c0-.8-.2-1.5-.5-2.2l15.4-15.5c.7.4 1.5.6 2.3.6 2.8 0 5.1-2.3 5.1-5.1 0-.9-.2-1.7-.6-2.4l11.6-11.7c.7.4 1.5.6 2.3.6 2.8 0 5.1-2.3 5.1-5.1s-1.9-5.2-4.8-5.2m-61.6 18.8c-.5-.1-1-.2-1.5-.2-1 0-1.9.3-2.7.8l-11.6-11.7c.5-.8.7-1.7.7-2.6 0-1-.3-2-.8-2.8l11.7-12.6c.8.5 1.7.8 2.7.8 2.4 0 4.3-1.6 4.9-3.8h12.4c.3.9.7 1.7 1.4 2.3l-17.2 29.8m23.4 22.9c-.8-.5-1.7-.8-2.7-.8s-1.9.3-2.7.8l-15.2-15.3c.3-.4.5-.9.6-1.4h34.7c.1.5.3.9.6 1.3l-15.3 15.4m14.8-19.6h-34.9c-.2-.7-.6-1.2-1-1.8l17.3-30c.3.1.7.1 1 .1s.7 0 1-.1l17.4 30.2c-.3.5-.6 1-.8 1.6m19-14.4l-11.5 11.6c-.8-.4-1.6-.7-2.6-.7-.6 0-1.1.1-1.6.3l-17.3-29.9c.7-.6 1.2-1.4 1.4-2.3h12.6c.6 2.2 2.6 3.8 4.9 3.8.9 0 1.8-.3 2.6-.7l11.7 12.6c-.5.8-.8 1.8-.8 2.8-.1.8.2 1.7.6 2.5"
    />
  </Svg.Icon>
)

export default IconGraphQl
